import {useRef, useState} from "react";
import styled, { keyframes } from "styled-components";
import emailjs from '@emailjs/browser';
import validator from 'validator'
import rollImage from '../media/images/contact_us_laptop.jpeg';
import spinner from '../media/images/spinner.gif';
import {MoreInfoButton} from "../elements/Button";
import { RiTimeZoneFill } from "react-icons/ri";
import { FaSpinner } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa6";
import { ImSpinner3 } from "react-icons/im";

const ContactUs = styled.div`
    font-family: "Roboto", "serif";
    width: 100%;
    height: 500px;
    background-image: url(${rollImage});
    background-size: cover;
    position: relative;
    display: block;
    @media (max-width: 800px) {
        background: none;
    }
`;

const ContactUsBox = styled.div`
    width: 490px;
    height: 350px;
    display: inline-block;
    background-color: #f9f9f9;
    //border-radius: 25px;
    margin-top: -25px;
    margin-left: 15%;
    padding: 50px;
    @media (max-width: 800px) {
        width: 100%;
        margin-left: 0;
        background-color: white;
    }
    @media (max-width: 500px) {
        width: 100%;
        margin-left: 0;
        background-color: white;
        padding: 20px;
    }
`;


const StyledHeader1 = styled.h1`
    color: #232323;
    font-family: "Roboto", "serif";
    font-size: 38px;
    font-weight: 900;
    @media (max-width: 800px) {
        font-size: 24px;
    }
`;

const StyledGreenHeader = styled.h5`
    color: #35644c;
    font-family: "Roboto", "serif";
    font-size: 14px;
    font-weight: bold;
`;

const StyledParagraph = styled.p`
    color: #232323;
    font-family: "Roboto", "serif";
    font-size: 16px;
    font-weight: 400;
    padding-bottom: 15px;
    width: 80%;
`;


const Form = styled.form`
    width: 500px;
    text-align: left;
    @media (max-width: 800px) {
        width: 90%;
    }
`

const StyledInput = styled.input`
    font-family: 'Montserrat';
    width: 96%;
    height: 20px;
    border-radius: 5px;
    font-size: 14px;
    margin-bottom: 10px;
    border-color: #c58e50;
    box-sizing: border-box;
    border-style: solid;
    border-width: 1px;
    &:focus {
        outline: none;
        box-shadow: 0 0 2px #c58e50;
    }
`

const StyledTextArea = styled.textarea`
    font-family: 'Montserrat';
    width: 96%;
    height: 60px;
    border-radius: 5px;
    font-size: 14px;
    margin-bottom: 10px;
    border-color: #c58e50;
    box-sizing: border-box;
    border-style: solid;
    border-width: 1px;
    resize: none;
    &:focus {
        outline: none;
        box-shadow: 0 0 2px #c58e50;
    }
`

const StyledButton = styled.button`
    font-size: 2em;
    background-color: black;
    color: white;
    cursor: pointer;
    width: 50px;
    height: 50px;
    display: inline-block;
    border: none;

    &:hover {
        opacity: .8;
    }
`

const StyledButtonSubmit = styled(StyledButton)`
    margin-left: 400px;
    @media (max-width: 800px) {
        margin-left: 140px;
    }
`

const StyledButtonIcon = styled.span`
    margin-top: 0px;
`
const Label = styled.label`
    font-family: 'Montserrat';
    display: block;
    font-size: 1em;
    color: #c58e50;
    @media (max-width: 800px) {
        font-size: .8em;
    }
`

const breatheAnimation = keyframes`
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
`

const SpinningIcon = styled(ImSpinner3)`
    font-size: 40px;
    color: #35644c;
    animation-name: ${breatheAnimation};
    animation-duration: 5000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
`

const SuccessIconn = styled(FaEnvelope)`
    font-size: 40px;
    color: #35644c;
`

const StiledButton = styled.div`
    font-family: "Montserrat", "serif";
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    color: black;
    border-radius: 25px;
    height: 35px;
    padding-top: 13px;
    float: left;
    margin-right: 15px;
    cursor: pointer;
    width: 219px;
    margin-top: 15px;
    &:hover {
        opacity: .9;
    }
`;

const StartButton = styled(StiledButton)`
    color: #ffffea;
    background-color: #c58e50;
`;

const NextButton = styled(StiledButton)`
    color: #ffffea;
    background-color: #c58e50;
    @media (max-width: 800px) {
        width: 95%;
    }
`;

const BackButtonn= styled(StiledButton)`
    color: #c58e50;
    background-color: #ffffea;
    margin-right: 45px;
    border: 1px solid #c58e50;
    @media (max-width: 800px) {
        width: 95%;
    }
`;

function Contact() {

    const formToSend = useRef();
    const currentView = useRef();
    const [form, setForm] = useState("formInitial");
    const [emailError, setEmailError] = useState(null)
    const [nameError, setNameError] = useState(null)
    const [phoneError, setPhoneError] = useState(null)

    const formStart = () => {
        setForm("formStart")
    }

    const returnToInitial = () => {
        setForm("formInitial")
    }

    const sendEmail = (e) => {
        e.preventDefault();

        let isEmailValid = validateEmail(e);
        let isNameValid = validateName(e);
        let isPhoneValid = validatePhone(e);

        if (isEmailValid && isNameValid && isPhoneValid) {
            setForm("formSending")
            alert(formToSend.current.message);
            emailjs.sendForm('service_b2aonui', 'template_pc3yts3', formToSend.current, '0dVNNPAf748H1jySQ')
                .then((result) => {
                    setForm("formSuccess")
                }, (sendingError) => {
                    console.log(sendingError);
                    setForm("formError")
                });
        }
    };


    const validateEmail = () => {
        let email = formToSend.current.email.value
        if (email && validator.isEmail(email)) {
            setEmailError(null)
            return true;
        } else {
            setEmailError(' - Моля, въведете валиден имейл адрес.')
            return false;
        }
    }

    const validateName = () => {
        if (formToSend.current.name.value) {
            setNameError(null)
            return true;
        } else {
            setNameError(' - Полето не може да бъде празно.')
            return false;
        }
    }

    const validatePhone = () => {
        if (formToSend.current.phone.value) {
            setPhoneError(null)
            return true;
        } else {
            setPhoneError(' - Моля въведете валиден телефон.')
            return false;
        }
    }


    if (form === "formInitial") {
        return (
            <ContactUs>
                <ContactUsBox>
                    <StyledGreenHeader>
                        СВЪРЖЕТЕ СЕ С НАС
                    </StyledGreenHeader>
                    <StyledHeader1>
                        Интересувате се от нашите продукти?
                    </StyledHeader1>
                    <StyledParagraph>
                        Свържете се с нас за повече информация и поръчки. Ще се радваме да отговорим на всички ваши
                        въпроси.
                    </StyledParagraph>
                    <StartButton onClick={() => formStart()}>Свържете се с нас</StartButton>
                </ContactUsBox>
            </ContactUs>
        );
    } else if (form === "formStart") {
        return (
            <ContactUs>
                <ContactUsBox>
                    <StyledGreenHeader>
                        СВЪРЖЕТЕ СЕ С НАС
                    </StyledGreenHeader>
                    <Form ref={formToSend}>
                        <Label htmlFor="email">Email * {emailError}</Label>
                        <StyledInput type="email" name="email" id="email"/>
                        <Label htmlFor="name">Име * {nameError}</Label>
                        <StyledInput type="text" name="name" id="name"/>
                        <Label htmlFor="phone">Телефон * {phoneError}</Label>
                        <StyledInput type="text" name="phone" id="phone"/>
                        <Label htmlFor="message">Съобщение</Label>
                        <StyledTextArea type="textarea" name="message" id="message"/>
                        <br/>
                        <BackButtonn type="button" onClick={(e) => returnToInitial()}>Назад</BackButtonn>
                        <NextButton type="button" onClick={(e) => sendEmail(e)}>Изпрати</NextButton>
                    </Form>
                </ContactUsBox>
            </ContactUs>
        );
    } else if (form === "formSending") {
        return (
            <ContactUs>
                <ContactUsBox>
                    <SpinningIcon/>
                    <StyledGreenHeader>
                        Съобщеннието се изпраща.
                    </StyledGreenHeader>
                </ContactUsBox>
            </ContactUs>
        );
    } else if (form === "formSuccess") {
        return (
            <ContactUs>
                <ContactUsBox>
                    <SuccessIconn/>
                    <StyledGreenHeader>
                        Съобщеннието е изпратено успешно.
                    </StyledGreenHeader>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <BackButtonn type="button" onClick={(e) => returnToInitial()}>Назад</BackButtonn>
                </ContactUsBox>
            </ContactUs>
        );
    } else if (form === "formError") {
        return (
            <ContactUs>
                <ContactUsBox>
                    <SuccessIconn/>
                    <StyledGreenHeader>
                        Възникна проблем при изпращането. Съобщеннието не беше изпратено успешно.
                    </StyledGreenHeader>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <BackButtonn type="button" onClick={(e) => returnToInitial()}>Назад</BackButtonn>
                </ContactUsBox>
            </ContactUs>
        );
    }
}

export default Contact;
